export const customlink = {
    background: "green",
    color: "white"
}